import React from 'react'
import { Grid } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { connect } from 'react-redux';
import { source } from 'react-aim';
import Labels from './../../../../common/Labels';
@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})

class Summary extends React.Component {

    render() {
        let suborgdata;
        let communityData;
        if (this.props.suborgDetails && this.props.suborgDetails.data && this.props.suborgDetails.data.length !== 0) {
            suborgdata = this.props.suborgDetails.data[0];
        }
        else {
            communityData = this.props.selectedPracticeFlowCommunity ? this.props.selectedPracticeFlowCommunity : ''
        }

        return (

            <Form noValidate
                className="formcyForm"
                ref={ref => this.form = ref}
                onValidSubmit={this.props.submit}
            >
                {suborgdata ?
                    <Grid >
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Labels
                                    name="Name"
                                    text={suborgdata && suborgdata.name} />

                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Labels
                                    name="Description"
                                    text={suborgdata && suborgdata.summary}
                                    htmlView={true} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid> :
                    <Grid >
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Labels
                                    name="Name"
                                    text={communityData && communityData.name} />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Labels
                                    name="Description"
                                    text={communityData && communityData.description}
                                    htmlView={true} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>}
            </Form>
        )
    }
}

function mapStateToProps(state) {
    return {
        suborgDetails: state.initiatives.suborgDetails,
        selectedPracticeFlowCommunity: state.initiatives.selectedPracticeFlowCommunity
    };
}

const connectedSummary = connect(mapStateToProps)(Summary);

export default connectedSummary